import { Button } from 'primereact/button';
import React, { type ReactNode, useEffect, useState } from 'react';
import { hasAuthParams, useAuth } from 'react-oidc-context';
import { PageLoader } from '@/components/PageLoader';

interface ProtectedAppProps {
  children: ReactNode;
}

 

export const ProtectedApp: React.FC<ProtectedAppProps> = (props) => {
  const { children } = props;
  const auth = useAuth();
  const [hasTriedSignin, setHasTriedSignin] = useState(false);

  useEffect(() => {
    if (!hasAuthParams() && !auth.isAuthenticated && !auth.activeNavigator && !auth.isLoading && !hasTriedSignin) {
      auth.signinRedirect();
      setHasTriedSignin(true);
    }
  }, [auth, hasTriedSignin]);

  if (auth.isLoading || auth.activeNavigator) {
    return <PageLoader visible={true} />;
  }

  if (auth.error) {
    return (
      <>
        <h1 className="text-lg font-['Teko',sans-serif] text-center mb-8">Oops. There has been a problem with authentication.</h1>
        <div className="flex justify-center text-center">
          <Button className={'btn-primary'} onClick={() => auth.signinRedirect()}>
            Login
          </Button>
        </div>
      </>
    );
  }

  if (!auth.isAuthenticated) {
    return (
      <>
        <h1 className="text-lg font-['Teko',sans-serif] text-center mb-8">Welcome back. Please login to your account.</h1>
        <div className="flex justify-center text-center">
          <Button className={'btn-primary'} onClick={() => auth.signinRedirect()}>
            Login
          </Button>
        </div>
      </>
    );
  }

  return children;
};
